import * as Sentry from '@sentry/react'

const isDev = import.meta.env.DEV

const logger = {
    debug: (...args) => { if (isDev) console.debug(...args) },
    info:  (...args) => { if (isDev) console.log(...args) },
    warn:  (...args) => {
        if (isDev) {
            console.warn(...args)
        } else {
            Sentry.addBreadcrumb({ level: 'warning', message: String(args[0]) })
        }
    },
    error: (error, context) => {
        if (isDev) {
            console.error(error, context)
        } else {
            Sentry.captureException(error, context ? { extra: context } : undefined)
        }
    },
}

export default logger
